const levelOrder = { debug: 0, info: 1, warn: 2, error: 3, silent: 4 } as const;

export type LogLevel = keyof typeof levelOrder;

const currentLevel = (() => {
  const envLevel = (import.meta.env.VITE_LOG_LEVEL || 'info').toLowerCase() as LogLevel;
  return levelOrder[envLevel] ?? levelOrder.info;
})();

export const log = (...args: any[]) => {
  if (currentLevel <= levelOrder.info) {
    console.log(...args);
  }
};

export const warn = (...args: any[]) => {
  if (currentLevel <= levelOrder.warn) {
    console.warn(...args);
  }
};

export const error = (...args: any[]) => {
  if (currentLevel <= levelOrder.error) {
    console.error(...args);
  }
};

export default { log, warn, error };
